import { all } from 'redux-saga/effects';
import CapLanguageProviderSagas from '@capillarytech/cap-ui-library/CapLanguageProvider/saga';

export default [
  {
    key: 'language',
    saga: function* languageProviderSaga() {
      yield all(CapLanguageProviderSagas.map(saga => saga.call()));
    },
  },
];
